import config from '__api/config';
import { zqhdApi } from '__api/zqhd/creatZqhdRequest';

export interface DrawInfo {
  drawTaskId: string; //抽奖任务编号
  consumeTimes: string; //消耗次数
}
type getTaskListRequest = {
  drawList: DrawInfo[];
};
// 查询任务列表
interface CompWelfareTaskRes {}

interface getTaskListResponse {
  data: CompWelfareTaskRes[];
}
/*同步抽奖信息*/
export async function SycnDrawInfo(request: getTaskListRequest) {
  const url = config.zqhpLink + '/activity/competition-welfare/synDrawInfo';
  return zqhdApi.fetch<getTaskListResponse>(url, request);
}
